import { Component } from '@angular/core';

@Component({
  templateUrl: 'smione-shell.component.html',
  styleUrls: [ 'smione-shell.component.scss' ]
})
export class SmiOneShellComponent {
}
